module.exports = __webpack_public_path__ + "img/hxsys1.dd821805.png";